// import { initializeApp } from '@firebase/app';
// import { getMessaging, getToken, onMessage } from '@firebase/messaging';

// const firebaseConfig = { 
//   apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
//   authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
//   projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
//   storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
//   messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
//   appId: process.env.REACT_APP_FIREBASE_APP_ID,
//   measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
// };
// const firebaseApp = initializeApp(firebaseConfig);
// const messaging = getMessaging(firebaseApp);
// const setupNotifications = async () => {
//   try {
//     // Request permission for notifications
//     const permission = await Notification.requestPermission();
    
//     if (permission === 'granted') {
//       console.log('Notification permission granted.');
//       // Get the FCM token
//       const token = await getToken(messaging);
//       console.log('FCM Token:', token);
//     } else {
//       console.log('Notification permission denied.');
//     }
//     // Handle foreground notifications
//     onMessage(messaging, (payload) => {
//       console.log('Foreground Message:', payload);
//       // Handle the notification or update your UI
//     });
//   } catch (error) {
//     console.error('Error setting up notifications:', error);
//   }
// };
// export { messaging, setupNotifications };


import { initializeApp } from '@firebase/app';
import { getMessaging, getToken, onMessage } from '@firebase/messaging';
import { toast } from 'react-toastify';

// Firebase configuration
const firebaseConfig = { 
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const firebaseApp = initializeApp(firebaseConfig);
const messaging = getMessaging(firebaseApp);

// Setup notifications
const setupNotifications = async () => {
  try {
    // Request permission for notifications
    const permission = await Notification.requestPermission();
    
    if (permission === 'granted') {
      console.log('Notification permission granted.');
      
      // Get the FCM token
      const token = await getToken(messaging);
      console.log('FCM Token:', token);
    } else {
      console.log('Notification permission denied.');
    }
    
    // Handle foreground notifications
    onMessage(messaging, (payload) => {
      console.log('Foreground Message:', payload);
      const { notification } = payload;

      if (notification) {
        const { title, body } = notification;

        // Show toast notification dynamically
        toast.info(`${title}: ${body}`);

        // Optional: Show native browser notification
        if ('Notification' in window) {
          new Notification(title, { body });
        }
      }
    });

  } catch (error) {
    console.error('Error setting up notifications:', error);
  }
};

export { messaging, setupNotifications };
